import {
  FormField,
  type FormFieldProps,
  Input,
  type InputProps,
  InputSize,
} from "@aurem/ui";
import { FormFieldSize } from "@aurem/ui/src/components/FormField/types";
import { useId } from "react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import { get } from "../../utils";

type IProps = Omit<InputProps, "label"> &
  Partial<Omit<FormFieldProps, "size">> & {
    name: string;
    formElementClass?: string;
    clear?: boolean;
  };

export const InputControl = (props: IProps) => {
  const {
    label,
    message,
    required,
    tooltipContent,
    accessory,
    formElementClass,
    name,
    invalid,
    clear,
    description,
    size = "md",
    ...restInputProps
  } = props;
  const { control } = useFormContext();
  const { errors } = useFormState();
  const errorMessage = get(errors, name)?.message as string | undefined;
  const inputId = useId();

  const formFieldSize: Record<InputSize, FormFieldSize> = {
    sm: "sm",
    md: "md",
    lg: "lg",
  };

  const inputElement = (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onFieldChange, onBlur, value } }) => {
        const handleClear = () => {
          onFieldChange("");
        };

        return (
          <Input
            {...restInputProps}
            required={required}
            name={name}
            onChange={onFieldChange}
            onBlur={onBlur}
            value={value}
            invalid={invalid || !!errorMessage}
            autoComplete="off"
            id={inputId}
            size={size}
            onClear={
              restInputProps.onClear || (clear ? handleClear : undefined)
            }
          />
        );
      }}
    />
  );

  return (
    <FormField
      label={label}
      message={message ?? errorMessage}
      description={description}
      required={required}
      tooltipContent={tooltipContent}
      className={formElementClass}
      accessory={accessory}
      htmlFor={inputId}
      size={formFieldSize[size]}
    >
      {inputElement}
    </FormField>
  );
};
